import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { IGenericCardProps, PrivacySettingsCard } from '@gik/inkind-page';
import { HeroIconName } from '@gik/ui';

export const sendGiftBoxCardBlockName = 'feature-checkbox-card';

interface IFeatureCheckboxCardProps extends IGenericCardProps {
  icon: HeroIconName;
  title: string;
  description: string;
  id?: string;
  className: string;
  locked?: boolean;
}

const FeatureCheckboxCard: React.FC<IFeatureCheckboxCardProps> = ({
  value,
  onChange,
  icon,
  title,
  description,
  className,
  locked,
  id,
}): JSX.Element => {
  const bem = bemBlock(sendGiftBoxCardBlockName);

  return (
    <PrivacySettingsCard
      id={id}
      className={bem(null, [{ disabled: !value || locked }], className)}
      title={title}
      icon={{
        name: icon,
      }}
      checkboxSize="xl"
      description={description}
      value={value}
      onChange={onChange}
      locked={locked}
    />
  );
};

export default FeatureCheckboxCard;
